module.exports = __webpack_public_path__ + "static/media/vizio-v-series.e8e11233.png";